import { convertFromIQueryResponseToIPageData, IPageData } from 'types/rest/IPageData';
import {
  IConversationData,
  IConversationQuery,
  IConversationResponse,
  IConversationsResponse,
} from '../../types/conversations/IConversation';
import { convertFromIPaginationQueryToIPaginationQueryRequest } from '../../types/rest/IPaginationQueryRequest';
import { convertFromISortQueryToISortQueryRequest } from '../../types/rest/ISortQueryRequest';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { paramsSerializer } from 'API/paramsSerializer';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';

const convertToApiQuery = ({ contactType, orderId, ...rest }: IConversationQuery) => ({
  contactType,
  orderId,
  ...convertFromIPaginationQueryToIPaginationQueryRequest(rest),
  ...convertFromISortQueryToISortQueryRequest(rest),
});

const convertResponseToData = (response: IConversationResponse): IConversationData => ({
  ...response,
});

export const getConversationsAsync = async (query: IConversationQuery): Promise<IPageData<IConversationData>> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IConversationsResponse>(`/timber/api/internal/genesys/conversations`, {
      params: convertToApiQuery(query),
      paramsSerializer,
    })
    .then((response) => convertFromIQueryResponseToIPageData(response.data, convertResponseToData))
    .catch(axiosErrorHandler);
